import React from 'react';
import { useSelector } from 'react-redux';

import { ANON_RECORD_A_REPLY } from 'constants/onboarding';
import { selectVideoId } from 'selectors/video';
import { selectPlayerTime } from 'selectors/videoPlayer';

import { SignUpForm } from '../../../signup/email-signup-form/signup-form';

const EmailSignupModal = ({
  email,
  emailError,
  backClickHandler,
  nextClickHandler,
}) => {
  const plainError = useSelector(state => state.login.plain_error);
  const passwordError = useSelector(state => state.login.password_error);
  const videoCurrentTime = useSelector(selectPlayerTime);
  const addReplyId = useSelector(state => state.modals?.options?.addReplyId);
  const recordedReplyVideoId = useSelector(
    state => state.modals?.options?.videoId
  );
  const repliedToVideoId = useSelector(selectVideoId);
  const isLoading = useSelector(state => state.login.is_fetching);

  const errorStr = plainError || passwordError || emailError;

  const signupParams = {
    recordedReplyVideoId,
    repliedToVideoId,
  };

  if (videoCurrentTime) {
    signupParams['videoCurrentTime'] = videoCurrentTime;
  }

  if (addReplyId) {
    signupParams['addReplyId'] = addReplyId;
  }

  return (
    <SignUpForm
      onClick={() => {
        backClickHandler();
      }}
      email={email}
      errorMessage={emailError}
      passwordError={passwordError}
      plainError={plainError}
      loading={isLoading}
      errorStr={errorStr}
      buttonSize="medium"
      modalMode={true}
      callback={nextClickHandler}
      onSignupParams={signupParams}
      source={ANON_RECORD_A_REPLY}
    />
  );
};

export default EmailSignupModal;
